import clsx from 'clsx';
import { useEffect, useState } from 'react';

import { CheckIcon, MinusIcon } from '~components/icons';
import styles from './Table.module.css';

export type TableCellHeaderCheckboxProps = {
  allItemsSelected: boolean;
  column: { id: number };
  updateData: (rowId: number, columnId: number, value: boolean) => void;
  disabled: boolean;
  canChange?: boolean;
  showMinusOnEmptyCheckbox?: boolean;
};

export const TableCellHeaderCheckbox = ({
  allItemsSelected: isChecked,
  column: { id },
  updateData,
  disabled,
  canChange = true,
  showMinusOnEmptyCheckbox = false,
}: TableCellHeaderCheckboxProps) => {
  const [checked, setChecked] = useState(isChecked);

  // Trigger: If isChecked is changed external, sync it up with our state
  useEffect(() => setChecked(isChecked), [isChecked]);

  // Handler: click
  const handleOnClick = () => !disabled && canChange && updateData(undefined, id, !checked);

  return (
    <div
      className={clsx(
        styles.cellCheckbox,
        canChange && styles.cellCheckboxCanChange,
        checked && styles.cellCheckboxChecked,
      )}
      onClick={handleOnClick}
    >
      {checked ? <CheckIcon /> : showMinusOnEmptyCheckbox ? <MinusIcon /> : null}
    </div>
  );
};
